module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    attrs: {
      "id": "app"
    }
  }, [_h('h1', ["\n        leo-vue-validator例子\n    "]), " ", _h('h3', ["\n        注意事项：必须先点击初始化按钮或者调用(initForm接口)才能验证\n    "]), " ", _h('h3', ["\n        状态参数（state）： 0: 没有验证过, 1: 通过, 2: 不通过, 3: 验证中\n    "]), " ", _h('h3', ["\n        自定义回调：\n        1.必须要设置item.state = 1才能验证下面的事项\n        2.必须调用回调参数cb()验证才开始\n    "]), " ", _h('h3', ["\n        改变forms中value的值 都会进行验证\n    "]), " ", _h('leo-validator', {
    ref: "leoForm",
    attrs: {
      "forms": _vm.form1,
      "tag": "div",
      "tagOptions": _vm.tagOptions1
    }
  }, [_h('h1', ["表单1(动态添加表单)"]), " ", _h('ul', {
    staticClass: "MoUpFlo_Module MoUpFlo_enterInfo"
  }, [_vm._l((_vm.form1), function(item, index) {
    return _h('li', {
      staticClass: "clearfix"
    }, [_h('label', [_h('span', ["item" + _vm._s(index) + ": "]), " ", _h('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.value),
        expression: "item.value"
      }],
      staticClass: "infoVal",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": _vm._s(item.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          item.value = $event.target.value
        }
      }
    })]), " ", _h('div', [_h('button', {
      on: {
        "click": function($event) {
          _vm.deleteItem(item)
        }
      }
    }, ["删除"]), " ", _h('button', {
      on: {
        "click": function($event) {
          _vm.deleteItem1(item)
        }
      }
    }, ["删除(不使用removeField 报错,初始化后）)"])]), " ", _h('p', ["状态：" + _vm._s(item.state) + "    提示：" + _vm._s(item.msg)])])
  })]), " ", _h('button', {
    on: {
      "click": _vm.initForm
    }
  }, ["初始化"]), " ", _h('button', {
    on: {
      "click": _vm.add
    }
  }, ["添加"]), " ", _h('button', {
    on: {
      "click": _vm.reset
    }
  }, ["重置"]), " ", _h('div', [_h('button', {
    on: {
      "click": function($event) {
        _vm.submit('all')
      }
    }
  }, ["提交(全部验证)"]), " ", _h('button', {
    on: {
      "click": function($event) {
        _vm.submit('first')
      }
    }
  }, ["提交（验证到第一个错误项）"])])]), " ", _h('leo-validator', {
    ref: "leoForm1",
    attrs: {
      "forms": _vm.form2,
      "tag": "div",
      "tagOptions": _vm.tagOptions2
    }
  }, [_h('h1', ["表单2"]), " ", _h('ul', [_h('li', {
    staticClass: "clearfix"
  }, [_h('label', [_h('span', ["没有验证 : "]), " ", _h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form2[1]['value']),
      expression: "form2[1]['value']"
    }],
    staticClass: "infoVal",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.form2[1]['value'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.form2[1],
          $$idx = 'value';
        if (!Array.isArray($$exp)) {
          _vm.form2[1]['value'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  })]), " ", _h('p', ["状态：" + _vm._s(_vm.form2[1]['state']) + "    提示：" + _vm._s(_vm.form2[1]['msg'])])]), " ", _h('li', {
    staticClass: "clearfix"
  }, [_h('label', [_h('span', ["手机号 : "]), " ", _h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form2[0]['value']),
      expression: "form2[0]['value']"
    }],
    staticClass: "infoVal",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.form2[0]['value'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.form2[0],
          $$idx = 'value';
        if (!Array.isArray($$exp)) {
          _vm.form2[0]['value'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  })]), " ", _h('p', ["状态：" + _vm._s(_vm.form2[0]['state']) + "    提示：" + _vm._s(_vm.form2[0]['msg'])])]), " ", _h('li', {
    staticClass: "clearfix"
  }, [_h('label', [_h('span', ["异步验证整组验证 : "]), " ", _h('p', ["（obj形式 失去焦点验证 password: 123456）"]), " ", _h('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.form2[2]['value']['user']),
      expression: "form2[2]['value']['user']",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "infoVal",
    attrs: {
      "placeholder": "user",
      "type": "text",
      "disabled": _vm.form2[2]['state'] == 3
    },
    domProps: {
      "value": _vm._s(_vm.form2[2]['value']['user'])
    },
    on: {
      "change": function($event) {
        var $$exp = _vm.form2[2]['value'],
          $$idx = 'user';
        if (!Array.isArray($$exp)) {
          _vm.form2[2]['value']['user'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  }), " ", _h('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.form2[2]['value']['password']),
      expression: "form2[2]['value']['password']",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "infoVal",
    attrs: {
      "placeholder": "password",
      "type": "text",
      "disabled": _vm.form2[2]['state'] == 3
    },
    domProps: {
      "value": _vm._s(_vm.form2[2]['value']['password'])
    },
    on: {
      "change": function($event) {
        var $$exp = _vm.form2[2]['value'],
          $$idx = 'password';
        if (!Array.isArray($$exp)) {
          _vm.form2[2]['value']['password'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  })]), " ", _h('p', ["状态：" + _vm._s(_vm.form2[2]['state']) + "    提示：" + _vm._s(_vm.form2[2]['msg'])])]), " ", _h('li', {
    staticClass: "clearfix"
  }, [_h('label', [_h('span', ["异步验证整组验证（array形式 失去焦点验证） : "]), " ", _h('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.form2[3].value[0]),
      expression: "form2[3].value[0]",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "infoVal",
    attrs: {
      "type": "text",
      "disabled": _vm.form2[3]['state'] == 3
    },
    domProps: {
      "value": _vm._s(_vm.form2[3].value[0])
    },
    on: {
      "change": function($event) {
        var $$exp = _vm.form2[3].value,
          $$idx = 0;
        if (!Array.isArray($$exp)) {
          _vm.form2[3].value[0] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  }), " ", _h('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.form2[3].value[1]),
      expression: "form2[3].value[1]",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "infoVal",
    attrs: {
      "type": "text",
      "disabled": _vm.form2[3]['state'] == 3
    },
    domProps: {
      "value": _vm._s(_vm.form2[3].value[1])
    },
    on: {
      "change": function($event) {
        var $$exp = _vm.form2[3].value,
          $$idx = 1;
        if (!Array.isArray($$exp)) {
          _vm.form2[3].value[1] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  })]), " ", _h('p', ["状态：" + _vm._s(_vm.form2[3]['state']) + "    提示：" + _vm._s(_vm.form2[3]['msg'])])])]), " ", _h('button', {
    on: {
      "click": _vm.initForm1
    }
  }, ["初始化"]), " ", _h('button', {
    on: {
      "click": _vm.reset1
    }
  }, ["重置"]), " ", _h('div', [_h('button', {
    on: {
      "click": function($event) {
        _vm.submit1('all')
      }
    }
  }, ["提交(全部验证)"]), " ", _h('button', {
    on: {
      "click": function($event) {
        _vm.submit1('first')
      }
    }
  }, ["提交（验证到第一个错误项）"])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ec8dfef2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 115
// module chunks = 2